module.exports = __webpack_public_path__ + "img/애고미_이모티콘-21.bc1ad3d.png";